import React from "react"

export const withCallout = Component => ({ name = "Callout", ...props }) => {
  Component.displayName = name
  const { callout } = props
  const desktopImage = { src: callout?.desktopImage }
  const mobileImage = callout?.mobileImage && { src: callout?.mobileImage }

  const desktopVideo = callout?.desktopVideo
  const mobileVideo = callout?.mobileVideo
  const colsNumber = parseInt(callout?.displayColumns, 10)

  return (
    <Component
      callout={callout}
      desktopImage={desktopImage}
      mobileImage={mobileImage}
      desktopVideo={desktopVideo}
      mobileVideo={mobileVideo}
      colsNumber={colsNumber}
      {...props}
    />
  )
}
